import UserFormModule from './containers/userFormModule'

export {default as UserFormModuleLayout} from './components/userFormModuleLayout'

export default UserFormModule
